import { UploadType } from './types'

export namespace Agents {
  export enum RunStatus {
    Preparing = 'preparing',
    Running = 'running',
    Pending = 'pending',
    Approved = 'approved',
    Issue = 'awaiting_question',
    Rejected = 'rejected',
    Error = 'error',
    TimedOut = 'timed_out',
  }

  export interface AgentOutput {
    id: string
    type: string
    name: string
    status: 'approve' | 'awaiting_question' | 'deny'
    instance_id: string
    result: string
    runtime: number
    thoughts: Array<{
      role: 'ai' | 'tool'
      content: string
      additional_info?: Array<{
        type: string
        content: string
      }>
    }>
    tickets: Record<string, unknown>
  }

  export interface WorkflowInput {
    name: string
    type: 'file' | 'string'
    url?: string
    filetype?: string
    value?: string
  }

  export interface IWorkflowRun {
    id?: string
    name?: string
    _ts?: number
    description?: string
    workflowId: string
    inputs?: Record<string, WorkflowInput>
    agents?: Record<string, AgentOutput>
    status: RunStatus
    workflowType?: UploadType
    error?: string
    data?: any
  }

  export class WorkflowRun implements IWorkflowRun {
    id?: string
    name?: string
    _ts?: number
    description?: string
    workflowId: string
    inputs?: Record<string, WorkflowInput>
    agents?: Record<string, AgentOutput>
    status: RunStatus
    workflowType?: UploadType
    error?: string
    data?: any

    static isActive(run: IWorkflowRun): boolean {
      if (![
        RunStatus.Preparing,
        RunStatus.Running,
        RunStatus.Pending,
      ].includes(run.status)) {
        return false
      }

      const dt = new Date(run._ts)
      const twoMinutesAgo = new Date(Date.now() - (1000 * 60 * 2.5))
      if (dt <= twoMinutesAgo) {
        console.warn('detected agent run that has not resolved in 2.5 minutes', run)
      }
      return dt > twoMinutesAgo
    }
  }

  export interface WorkflowSearchResponse {
    success: boolean
    data: IWorkflowRun[]
    totalMatches: number
    statusCode: number
  }

  export interface PostRunResponse {
    success: boolean
    message: string
    data: {
      runId: string
    }
    statusCode: number
  }
}
